import React, { useEffect } from 'react';
import '../styles/gamification.css';

const COLORS = ['#fbbf24', '#22d3ee', '#a78bfa', '#34d399', '#f472b6'];

// Célébration de déblocage d'un badge bonus — CSS pur, sans dépendance.
export const BadgeUnlockModal = ({ badge, onClose }) => {
  useEffect(() => {
    if (!badge) return undefined;
    const t = setTimeout(onClose, 6500);
    return () => clearTimeout(t);
  }, [badge, onClose]);

  if (!badge) return null;
  const pieces = Array.from({ length: 44 });

  return (
    <div
      className="fixed inset-0 z-[101] flex items-center justify-center bg-black/75 backdrop-blur-sm p-4"
      onClick={onClose}
      data-testid="badge-unlock-modal"
    >
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        {pieces.map((_, i) => (
          <span
            key={i}
            className="confetti-piece"
            style={{
              left: `${(i * 2.3) % 100}%`,
              animationDelay: `${(i % 12) * 0.12}s`,
              background: COLORS[i % COLORS.length],
            }}
          />
        ))}
      </div>
      <div className="relative text-center px-6" onClick={(e) => e.stopPropagation()} style={{ animation: 'levelpop 0.6s ease-out' }}>
        <p className="text-violet-300 text-xs font-semibold tracking-[0.3em] uppercase mb-4">Badge débloqué</p>
        <div className="mx-auto w-36 h-36 sm:w-44 sm:h-44 mb-5">
          <img src={badge.badge} alt={badge.nom} className="w-full h-full object-contain drop-shadow-[0_0_30px_rgba(167,139,250,0.55)]" />
        </div>
        <h2 className="text-2xl sm:text-3xl font-bold text-white" data-testid="badge-unlock-name">{badge.nom}</h2>
        <p className="text-slate-300 mt-2 italic max-w-sm mx-auto">{badge.desc}</p>
        <button
          onClick={onClose}
          data-testid="badge-unlock-continue"
          className="mt-6 px-7 py-2.5 rounded-full bg-white text-slate-900 font-medium hover:bg-slate-100 active:scale-95 transition-all"
        >
          Continuer
        </button>
      </div>
    </div>
  );
};
